import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { MasterDB } from 'src/app/DAO/MasterDB';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { PlaneacionService } from 'src/app/services/planeacion.service';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { Negocios } from 'src/app/types/Entitys';
import { Estacion, Region, ResponseValidaUsaurio, Revisiones, TipoRevision } from 'src/app/types/type';
declare var $: any;

@Component({
  selector: 'app-form-new-revision',
  templateUrl: './form-new-revision.component.html',
  styleUrls: ['./form-new-revision.component.css']
})
export class FormNewRevisionComponent {
  @Input() negocios: Negocios[];
  @Input() tipoRevisiones: TipoRevision[];
  @Output() saveRevision = new EventEmitter();
  regiones: Region[];
  estaciones: Estacion[];
  form: FormGroup;
  descriptionRegionSitio: string = 'Estación/Sitio'


  constructor(
    private formBuilder: FormBuilder,
    private userService: UsuariosService,
    private revisionServicio: PlaneacionService,
    private router: Router
  ) { }

  ngOnInit() {
    this.buildForm()
  }

  buildForm() {
    this.form = this.formBuilder.group({
      objetivo: ['', [Validators.required]],
      alcance: ['', [Validators.required]],
      negocio: [0, [Validators.required, Validators.min(1)]],
      region: [0, [Validators.required, Validators.min(1)]],
      estacion: [0, [Validators.required, Validators.min(1)]],
      fechaInicio: ['dd/mm/aaaa', [Validators.required]],
      fechaFin: ['dd/mm/aaaa', [Validators.required]],
      tipoRevision: [0, [Validators.required, Validators.min(1)]],
    });
  }

  changeNegocio(event: Event) {
    const inpunt = event.target as HTMLInputElement;
    const idNegocio = parseInt(inpunt.value)

    if (idNegocio === 1)
      this.descriptionRegionSitio = 'Estación';
    else if (idNegocio === 2)
      this.descriptionRegionSitio = 'Sitios';

    this.userService.getCatalogoRegiones({ Negocio_Id: idNegocio })
      .subscribe(resp => {
        if (resp?.Result?.Exito) {
          this.regiones = resp.Result.Data as Region[]
          this.form.patchValue({ estacion: '0' })
          this.form.enable()
        }
        else
          Utilerias.alertClient('', resp?.Result?.Error, 1);
      })
  }

  changeRegion(event: Event) {
    const inpunt = event.target as HTMLInputElement;
    const idRegion = parseInt(inpunt.value)
    this.userService.getEstaciones(idRegion)
      .subscribe(resp => {
        if (resp?.Result?.Exito)
          this.estaciones = resp.Result.Data as Estacion[]
      })
  }

  async saveRevisionHandler() {
    if (this.form.valid) {
      const { IdEmpleado } = await MasterDB.getUsuarioSesion(new EstacionesTVADB())

      const {
        objetivo,
        alcance,
        negocio,
        region,
        estacion,
        fechaInicio,
        fechaFin,
        tipoRevision
      } = this.form.value;

      const newPlaneacion = {
        r: {
          objetivo,
          alcance,
          Negocio_Id: negocio,
          IdRegion: region,
          IdEstacion: estacion,
          FechaInicioPlan: fechaInicio,
          FechaFinPlan: fechaFin,
          IdTipoRevision: tipoRevision,
          IdEmpleadoAlta: IdEmpleado
        }
      };

      this.userService.validarUsuario({
        usuario: {
          Token: localStorage['Token'],
          Browser: localStorage['Browser'],
          IdTipoAplicacion: 1,
          IdEmpleado: localStorage['IdEmpleado'],
          IpSesion: localStorage['IpSesion'],
          Roles: JSON.parse(localStorage['Roles'])
        }
      })
        .pipe(
          switchMap(
            (userValid) => {
              if (userValid?.Result?.Exito) {
                const { exito, mensaje } = userValid.Result.Data as ResponseValidaUsaurio
                if (exito)
                  return this.revisionServicio.nuevaRevision(newPlaneacion)
                else {
                  Utilerias.alertClient('', mensaje, 1);
                  this.router.navigate([`/`]);
                }
              } else {
                Utilerias.alertClient('', userValid?.Result?.Error, 1);
                this.router.navigate([`/`]);
              }
            }
          )
        )
        .subscribe((response) => {
          if (response?.Result?.Exito) {
            const revision = response.Result.Data as Revisiones
            this.saveRevision.emit(revision)
            this.form.reset()
            $('#modalAltaRevision').modal('toggle');
          } else
            Utilerias.alertClient('', response?.Result?.Error, 1);
        })
    }
  }
}
